import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserLoggedInState } from './loggedInUser.state';

export const getLoggedInUserState = createFeatureSelector<UserLoggedInState>('loggedInUser');

export const getLoggedInUser = createSelector(
  getLoggedInUserState,
  (state) => state.loggedInUser
);
